export const PRIVACY_CONSENT_ROLE_IDS = [1, 2, 3]

export function userRequiresPrivacyConsent(roleId) {
  return PRIVACY_CONSENT_ROLE_IDS.includes(Number(roleId))
}
